
  document.addEventListener('DOMContentLoaded', function () {
    const quoteButton = document.querySelector('.open-quote-form');
    if (quoteButton) {
      quoteButton.addEventListener('click', function () {
        const title = this.getAttribute('data-product-title');
        const sku = this.getAttribute('data-product-sku');

        const quoteData = {
          title: title,
          sku: sku
        };

        localStorage.setItem('quoteProduct', JSON.stringify(quoteData));
      });
    }
  });




  // Find the link with text "Exclusive Offers"
let exclusiveLink = Array.from(document.querySelectorAll('.mega-menu-column a'))
  .find(link => link.textContent.trim() === "Exclusive Offers");

// If found, add a special class
if (exclusiveLink) {
  exclusiveLink.classList.add("exclusive-gradient");
}


